import React, { useContext, createContext } from "react";

const axiosImport = require('axios').default;

let handlerTemp: any = null;

const axiosContext = createContext({
    axios: {
        post: post,
        delete: deleteFunc,
        get: get,
        put: put,
        all: all,
        single: single,
        spread: spread
    },
});

export function ProvideAxios({ children }: any) {
    const axios = useProvideAxios();
    return <axiosContext.Provider value={axios}>{children}</axiosContext.Provider>;
}

export const useAxios = () => {
    return useContext(axiosContext);
};

function unauthorizedHandler(error: any) {
    if (error.response.status === 401 || error.response.status === 403) {
        console.log("Axios unauthorized error!");
        
        return Promise.reject(error);
    }
    if (error.response.status < 400 || error.response.status >= 500) {
        console.log("Something went wrong!");
    }
    return Promise.reject(error);
}

function put(link: string, data: Object, config: Object) {
    if (handlerTemp == null) {
        handlerTemp = axiosImport.interceptors.response.use(undefined, unauthorizedHandler);
    }
    const promise = axiosImport.put(link, data, config);
    return promise;
}

function post(link: string, data: Object, config: Object) {
    if (handlerTemp == null) {
        handlerTemp = axiosImport.interceptors.response.use(undefined, unauthorizedHandler);
    }
    const promise = axiosImport.post(link, data, config);
    return promise;
}

function deleteFunc(link: string, data: Object, config: any) {
    if (handlerTemp == null) {
        handlerTemp = axiosImport.interceptors.response.use(undefined, unauthorizedHandler);
    }
    const promise = axiosImport.delete(link, { headers: config.headers, data });
    return promise;
}

function get(link: string, data: Object, config: Object) {
    if (handlerTemp == null) {
        handlerTemp = axiosImport.interceptors.response.use(undefined, unauthorizedHandler);
    }
    const promise = axiosImport.get(link, data, config);
    return promise;
}

function single(data: Object) {
    if (handlerTemp == null) {
        handlerTemp = axiosImport.interceptors.response.use(undefined, unauthorizedHandler);
    }
    const promise = axiosImport(data);
    return promise;
}

function all(data: Object) {
    if (handlerTemp == null) {
        handlerTemp = axiosImport.interceptors.response.use(undefined, unauthorizedHandler);
    }
    const promise = axiosImport.all(data);
    return promise;
}

function spread(data: Object) {
    if (handlerTemp == null) {
        handlerTemp = axiosImport.interceptors.response.use(undefined, unauthorizedHandler);
    }
    return axiosImport.spread(data);
}

function useProvideAxios() {
    if (handlerTemp == null) {
        handlerTemp = axiosImport.interceptors.response.use(undefined, unauthorizedHandler);
    }
    return {
        axios: axiosImport,
    };
}